'use strict';
define([
    "dojo/_base/declare",
    "mw-filebrowser/actions/Action",
    "util",
    "dojo/i18n!nls/mldoStringResource",
], function (declare, Action, Util, MLDOStrings) {
  return declare(Action, {
    constructor: function (args) {
        args = args || {};
        var context = args.context;
        var makeActionAvailable = args.showAction || false;
        this.name =  "linkAction";
        this.label = MLDOStrings.contextMenuManageLinkLabel;
        this.id = "mldoLinkAction";
        this.enabled = makeActionAvailable;
        this.section = args.isSubMenu ? {
            id: "shareSub",
            enabled: false,
            isApplicableTo: function() { return false; },
            label: "shareSub",
            parent: {
                id: "mldoShareAction",
                name: MLDOStrings.contextMenuShareLabel,
                label: MLDOStrings.contextMenuShareLabel,
                allowSubMenu: true,
                forceSubMenu: true
            }
        } : {
          id: "MISC",
          name: "MISC",
          allowSubMenu: false,
          forceSubMenu: false
        };
        this.supportsKeyBinding = false;
        this.isApplicableTo = function (path) {
          var selectedFileCount = context.getSelectedRowCount();
          let fileInfo;
          if (selectedFileCount > 1) {
            this.enabled = false;
            return false;
          } else if (selectedFileCount === 0) {
            fileInfo = context.getCurrentFolderInfo();
          } else {
            fileInfo = context.getSelectedItemFileInfos()[0];
          }

          const isInShare = fileInfo.isSharedFolder || !!fileInfo.sharedParentPath;
          const isOwner = fileInfo.accessType && fileInfo.accessType.toUpperCase() === "OWNER";
          const hasActiveLink = fileInfo.hasActiveLink;
          
          // Disable for MLD root and for files that are not shareable
          if (fileInfo.name === "/" || (!fileInfo.isDirectory && !fileInfo.shareable)) {
            this.enabled = false;
            return false;
          }
          if (isOwner) {
            if (!isInShare || (isInShare && !hasActiveLink)) {
              this.label = MLDOStrings.contextMenuCreateLinkLabel; // Unshared content via link
            } else if (isInShare && hasActiveLink) {
              this.label = MLDOStrings.contextMenuManageLinkLabel; // Shared folder root or its contents
            } else if (!hasActiveLink) {
              this.enabled = false; return false;   // within share shared via personal 
            } else {
              this.label = MLDOStrings.contextMenuViewLinkLabel;
            }
            this.enabled = true;
            return true;
          }
        
          if (isInShare && hasActiveLink) { // Non-owner cases
            this.label = MLDOStrings.contextMenuViewLinkLabel;
            this.enabled = true;
            return true;
          }
          this.enabled = false;
          return false;
        };
        this.callback = function (action) {
          var fileInfos = context.getSelectedItemFileInfos();
          var sortedFileInfos;
          var fileInfo;
          var path;
          if (fileInfos.length) {
            sortedFileInfos = Util.sortFileInfosByPath(fileInfos);
            fileInfo = fileInfos[0];
            path = context.getSelectedItemFullPath(fileInfo);
          } else {
            path = context.getSelectedItemFullPath();
            fileInfo = context.fileService.getCurrentFolderInfo();
            fileInfo.path = path;
          }

          // override if there is a linkPath value
          if ("linkPath" in fileInfo && fileInfo.linkPath && fileInfo.linkPath.length) {
            path = fileInfo.linkPath;
          }
          if (this.isApplicableTo()) {
            if (fileInfos.length <= 1 && fileInfo && path) {
              context.handleLinkAction(path, fileInfo);
            }
          }
        };
    }
  });

});
